<template>
    <div class="c-ratings-box">
        <div class="c-ratings-box__filter" v-if="filteredStars != 'all'">
            <div class="c-ratings-filter">
                <div class="c-ratings-filter__title">
                    {{ $t("Ratings.Filter.title") }}
                </div>

                <div class="c-ratings-filter__item" v-if="false">
                    <button
                        type="button"
                        class="c-btn"
                        :class="{ 'is-active': filteredLocale == 'all' }"
                        @click="setLocaleFilter('all')"
                    >
                        <div class="sc-circle"></div>
                        <div class="sc-text">{{ $t("Ratings.General.all") }}</div>
                    </button>
                </div>

                <div class="c-ratings-filter__item" v-if="false">
                    <button
                        type="button"
                        class="c-btn"
                        :class="{ 'is-active': filteredLocale == locale }"
                        @click="setLocaleFilter(locale)"
                    >
                        <div class="sc-circle"></div>
                        <div class="sc-text">{{ $t(`Ratings.Only.${locale}`) }}</div>
                    </button>
                </div>

                <div class="c-ratings-filter__item" @click="setStarsFilter('all')">
                    <div class="sc-key">
                        {{ $t("Ratings.Filter.stars") }}
                    </div>

                    <div class="sc-value">
                        {{ filteredStars }}
                    </div>

                    <i class="ico ico-x"></i>
                </div>

                <div class="c-ratings-filter__item is-reset" @click="setStarsFilter('all')">
                    <i class="ico ico-x"></i>

                    <div class="sc-value">
                        {{ $t("Ratings.Filter.reset") }}
                    </div>
                </div>
            </div>
        </div>

        <div class="c-ratings-box__list" :class="{ 'has-limit': showMore }">
            <div
                class="c-ratings-box__item"
                v-for="(rating, index) in limitedFilteredRatings"
                :key="rating.id"
            >
                <div class="sc-header">
                    <div class="c-stars">
                        <div class="c-stars__empty">
                            <i class="ico ico-star" aria-hidden="true"></i>
                            <i class="ico ico-star" aria-hidden="true"></i>
                            <i class="ico ico-star" aria-hidden="true"></i>
                            <i class="ico ico-star" aria-hidden="true"></i>
                            <i class="ico ico-star" aria-hidden="true"></i>
                        </div>

                        <div class="c-stars__full" :style="`width: ${rating.rating}%;`">
                            <i class="ico ico-star" aria-hidden="true"></i>
                            <i class="ico ico-star" aria-hidden="true"></i>
                            <i class="ico ico-star" aria-hidden="true"></i>
                            <i class="ico ico-star" aria-hidden="true"></i>
                            <i class="ico ico-star" aria-hidden="true"></i>
                        </div>
                    </div>
                    <div class="sc-header__author">
                        {{
                            rating.customer_name
                                ? makeInitials(rating.customer_name)
                                : $t("Ratings.General.anonymous")
                        }}

                        <div class="sc-date">
                            {{ formatDate(rating.created) }}
                        </div>
                    </div>
                </div>

                <div class="sc-description" v-if="rating.description">
                    {{ rating.description }}
                </div>

                <div class="sc-list" v-if="rating.pros || rating.cons">
                    <div class="sc-list__column" v-if="rating.pros">
                        <div
                            class="sc-list__item"
                            v-for="(pro, index) in rating.pros.split('\n')"
                            :key="index"
                        >
                            <i class="ico ico-plus-circle"></i>
                            <span class="sc-text">{{ pro }}</span>
                        </div>
                    </div>

                    <div class="sc-list__column" v-if="rating.cons">
                        <div
                            class="sc-list__item"
                            v-for="(con, index) in rating.cons.split('\n')"
                            :key="index"
                        >
                            <i class="ico ico-minus-circle"></i>
                            <span class="sc-text">{{ con }}</span>
                        </div>
                    </div>
                </div>
                <div class="c-ratings-box__useful">
                    <span class="is-label">{{ $t("Ratings.General.isUseful") }}</span>

                    <button
                        :class="['c-btn', { 'is-clicked': isUsefulClicked(rating) }]"
                        @click="handleRatingFeedback(rating, index, true)"
                        :disabled="isFeedbackDisabled(rating)"
                    >
                        <i :class="getFeedbackIconClass(rating, true)" aria-hidden="true"></i>
                        <span class="is-count">{{ rating.positive_rating_count ?? 0 }}</span>
                    </button>

                    <button
                        :class="['c-btn', { 'is-clicked': isUselessClicked(rating) }]"
                        @click="handleRatingFeedback(rating, index, false)"
                        :disabled="isFeedbackDisabled(rating)"
                    >
                        <i :class="getFeedbackIconClass(rating, false)" aria-hidden="true"></i>
                        <span class="is-count">{{ rating.negative_rating_count ?? 0 }}</span>
                    </button>
                </div>

                <div class="c-ratings-box__shop-answer" v-if="rating.answer">
                    <h4 class="c-ratings-box__shop-answer__title">{{ $t("Ratings.General.shopAnswer") }}</h4>

                    <div class="c-ratings-box__shop-answer__text" v-html="rating.answer"></div>
                </div>
            </div>
        </div>

        <div class="c-ratings-box__more" v-if="showMore">
            <button
                type="button"
                :title="$t('Ratings.General.more')"
                class="c-btn c-btn--secondary"
                @click.prevent="moreRatings = true"
            >
                <span class="sc-text">{{ $t("Ratings.General.more") }}</span>
                <i class="ico ico-chevron-down" aria-hidden="true"></i>
            </button>
        </div>
    </div>
</template>

<script>
import client from "./../../../../vendor/rshop/frontend/assets/js/common/client";
import { CancelToken } from "axios";

export default {
    data() {
        return {
            isInitialized: false,
            isLogged: !!Eshop.options.isLogged,
            fetchCancelToken: null,
            fetchingRatings: true,
            ratings: [],
            ratingsLimit: 6,
            locales: [],
            productId: document.querySelector(".js-product-detail").getAttribute("data-product-id"),
            filteredLocale: Eshop.options.locale,
            filteredStars: "all",
            locale: Eshop.options.locale,
            moreRatings: false,
        };
    },
    created() {
        this.fetchRatingsBox();

        rEvent.on("Rating.triggerFilter", (starsNumber, ratingsCount) => {
            if (ratingsCount > 0) {
                this.setStarsFilter(starsNumber);
            }
        });
    },
    methods: {
        cancelFetchRatingsBox() {
            if (this.fetchCancelToken) {
                this.fetchCancelToken.cancel();
            }

            this.fetchCancelToken = CancelToken.source();
        },
        fetchRatingsBox() {
            this.cancelFetchRatingsBox();
            this.fetchRatings();
        },
        fetchRatings() {
            this.fetchingRatings = true;

            client
                .get(`/fetch-ratings/${this.productId}`, {
                    cancelToken: this.fetchCancelToken.token,
                })
                .then((response) => {
                    if (!response.data.status) {
                        return;
                    }

                    this.ratings = Object.values(response.data.data.ratings);
                    this.locales = Object.values(response.data.data.locales);
                    this.isInitialized = true;
                })
                .catch((error) => {})
                .then(() => {
                    this.fetchingRatings = false;
                });
        },
        handleRatingFeedback(rating, index, isUseful) {
            // check if user is logged
            if (!this.isLogged) {
                $("#login-modal").modal("show");
                return;
            }

            // update frontend visual
            if (isUseful) {
                this.$set(
                    this.limitedFilteredRatings[index],
                    "positive_rating_count",
                    this.limitedFilteredRatings[index].positive_rating_count + 1
                );
                this.$set(this.limitedFilteredRatings[index], "usefulClicked", true);
            } else {
                this.$set(
                    this.limitedFilteredRatings[index],
                    "negative_rating_count",
                    this.limitedFilteredRatings[index].negative_rating_count + 1
                );
                this.$set(this.limitedFilteredRatings[index], "uselessClicked", true);
            }

            // update BE with API
            client
                .post(`/rate-product-rating`, {
                    cancelToken: this.fetchCancelToken.token,
                    rating_id: rating.id,
                    rating: isUseful,
                })
                .then((response) => {
                    window.Eshop.alert(response.data.message, {
                        type: response.data.status ? "success" : "error",
                    });
                    if (!response.data.status) {
                        return;
                    }
                    this.ratings = Object.values(response.data.data.ratings);
                    this.locales = Object.values(response.data.data.locales);
                    this.isInitialized = true;
                })
                .catch((error) => {})
                .then(() => {
                    this.fetchingRatings = false;
                });
        },
        setLocaleFilter(locale) {
            this.filteredLocale = locale;
            this.moreRatings = false;
        },
        setStarsFilter(starsNumber) {
            this.filteredStars = starsNumber;
            this.moreRatings = false;
        },
        formatDate(date) {
            const d = new Date(date);

            return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`;
        },
        makeInitials(name) {
            const words = name.split(" ");

            // Check if there are any words to process.
            if (words.length === 0) {
                return "";
            }

            // Keep the first word (first name) as is.
            const firstName = words[0];

            // Map through the rest of the words to convert them into initials, if any.
            const initials = words.slice(1).map((word) => {
                if (word.length > 0) {
                    return word[0].toUpperCase() + ".";
                }

                return "";
            });

            // Combine the full first name with the initials of the rest of the names.
            return [firstName, ...initials].join(" ");
        },
        isUsefulClicked(rating) {
            return rating.usefulClicked || rating.customers_product_ratings[0]?.rating;
        },

        isUselessClicked(rating) {
            return (
                rating.uselessClicked ||
                (rating.customers_product_ratings?.[0]?.rating !== undefined
                    ? !rating.customers_product_ratings[0].rating
                    : false)
            );
        },

        isFeedbackDisabled(rating) {
            return (
                rating.usefulClicked ||
                rating.uselessClicked ||
                rating.customers_product_ratings.length > 0
            );
        },

        getFeedbackIconClass(rating, isUseful) {
            const clicked = isUseful ? this.isUsefulClicked(rating) : this.isUselessClicked(rating);
            return clicked ? "ico ico-thumb-up-full" : "ico ico-thumb-up";
        },
    },
    computed: {
        filteredRatings() {
            return this.ratings.filter((rating) => {
                const localeResult =
                    rating.locale == this.filteredLocale || this.filteredLocale == "all";
                const starsResult =
                    Math.ceil(rating.rating / 20) == this.filteredStars ||
                    this.filteredStars == "all";

                return localeResult && starsResult;
            });
        },
        limitedFilteredRatings() {
            return this.filteredRatings.length > this.ratingsLimit && !this.moreRatings
                ? this.filteredRatings.slice(0, this.ratingsLimit)
                : this.filteredRatings;
        },
        showMore() {
            return this.filteredRatings.length > this.ratingsLimit && !this.moreRatings;
        },
    },
};
</script>
